import React from 'react';
import '../About/grids.css';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';
const Grids = ({ icon, title, body, className }) => {
	return (
		<div>
			<div className={className}>
				<div className="single-card">
					<div className="container-card bg-green-box">
						{icon}
						<p className="card-title">{title}</p>
						<AnimatedOnScroll animationIn="bounceInRight">
							<p className="card-description">{body}</p>
						</AnimatedOnScroll>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Grids;
